export default function assessmentUniqueNameDirective(
  $q,
  ecatDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const assessmentId = attributes.assessmentId || 0;
    ngModel.$asyncValidators.ecatAssessmentUniqueName = (modelValue) => {
      const defer = $q.defer();
      ecatDataService.checkAssessmentExists(modelValue, assessmentId).then((data) => {
        if (data && data.data.result === false) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'ecatAssessmentUniqueName';

assessmentUniqueNameDirective.$inject = [
  '$q',
  'ecatDataService'
];
